import axios from 'axios'
import store from '../store'
import router from '../router'
import Cookie from "js-cookie";

// Request interceptor
axios.interceptors.request.use(request => {
    if (store.getters.isAuthenticated) {
        //TODO create auth service, use LocalStorage...
        const token = Cookie.get('token')
        if (token) {
            request.headers.common['Authorization'] = `Bearer ${token}`
        }
    }

    return request
});

console.log('interceptors');

// Response interceptor
axios.interceptors.response.use(response => response, error => {
    const { status } = error.response

    if (status === 401 && store.getters['isAuthenticated']) {
        store.dispatch('logout')
        router.push({ name: 'auth.login' })
    } else {
        return Promise.reject(error)
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap/auth.js